// extracted by mini-css-extract-plugin
export var productImage = "_n6-1";
export var viewLink = "_n6-2";
export var wishlistItem = "_n6-0";